import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MailmergeHeaderComponent } from './mailmerge-header.component';
import { MailmergeHeaderCellModule } from '../header-cell/header-cell.module';
import { EventSpyModule } from '@schoolbelle/common/table';

 
@NgModule({
  declarations: [MailmergeHeaderComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    MailmergeHeaderCellModule,
    EventSpyModule,
  ],
  exports:[MailmergeHeaderComponent],
})
export class MailmergeHeaderModule { }
